import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const BASE = API_CONFIG.ENDPOINTS.BARCODE_SETTINGS;

const barcodeSettingsService = {
  /**
   * List all label formats for the current company.
   * @returns {Promise<Array>} List of { id, formatName, labelWidthMm, ... }
   */
  getFormats: async () => {
    try {
      const response = await axiosInstance.get(BASE);
      const data = response.data;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.content)) return data.content;
      return [];
    } catch (error) {
      console.error('Error fetching barcode formats:', error);
      throw error;
    }
  },

  /**
   * Get one format by id (must belong to current company).
   * @param {number} id - Format id
   * @returns {Promise<Object>} Format settings
   */
  getFormatById: async (id) => {
    try {
      const response = await axiosInstance.get(`${BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching barcode format:', error);
      throw error;
    }
  },

  /**
   * Save (create or update) a format. For create, formatName is required; for update, send id.
   * @param {Object} data - { formatName, id?, labelWidthMm, labelHeightMm, ... }
   * @returns {Promise<Object>} Saved format response
   */
  saveSettings: async (data) => {
    try {
      const response = await axiosInstance.put(BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving barcode settings:', error);
      throw error;
    }
  }
};

export default barcodeSettingsService;
